
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class MisReportsReaderService {

   public static getDailySalesData(
           axiosInstance: AxiosInstance, input: ServerData.MisReportsWebReader.GetDailySalesData$Input,
           f: (output: ServerData.MisReportsWebReader.GetDailySalesData$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'insightapi/misreports/get-daily-sales-data',
            {params : input.toJson()}
        ).then((response) => ServerData.MisReportsWebReader.GetDailySalesData$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getSaleCountDayWiseList(
           axiosInstance: AxiosInstance, input: ServerData.MisReportsWebReader.GetSaleCountDayWiseList$Input,
           f: (output: ServerData.MisReportsWebReader.GetSaleCountDayWiseList$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'insightapi/misreports/get-sale-count-day-wise-list',
            {params : input.toJson()}
        ).then((response) => ServerData.MisReportsWebReader.GetSaleCountDayWiseList$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getMandateCountDayWiseList(
           axiosInstance: AxiosInstance, input: ServerData.MisReportsWebReader.GetMandateCountDayWiseList$Input,
           f: (output: ServerData.MisReportsWebReader.GetMandateCountDayWiseList$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'insightapi/misreports/get-mandate-count-day-wise-list',
            {params : input.toJson()}
        ).then((response) => ServerData.MisReportsWebReader.GetMandateCountDayWiseList$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

